export default __webpack_public_path__ + "static/media/arrow_back.57771d96.svg";